import { API } from '../utils/amplifyApi';
const getApartmentAvailabilities = async (apartmentId: string) => {
    const availability: any[] = await API.get('applicantAvailability', `/apartments/${apartmentId}/applicantAvailability`, {});
    return availability;
};
const getApartmentAvailabilitiesByApplicants = async (apartmentId: string, applicationId: string) => {
    const availability: any[] = await API.get('applicantAvailability', `/apartments/${apartmentId}/applications/${applicationId}/applicantAvailability`, {});
    return availability;
};
const createAvailabilities = async (availabilities: any[]) => {
    const newAvailabilities: any[] = await API.post('applicantAvailability', `/applicantAvailability`, { body: availabilities });
    return newAvailabilities;
};
const deleteAvailability = async (applicantAvailabilityId: string) => {
    const availability: any[] = await API.del('applicantAvailability', `/applicantAvailability/${applicantAvailabilityId}`, {});
    return availability;
};
export default {
    getApartmentAvailabilities,
    getApartmentAvailabilitiesByApplicants,
    createAvailabilities,
    deleteAvailability
};
